<template>
  <section class="bg-white dark:bg-gray-900">
    <div class="py-8 px-4 mx-auto max-w-2xl lg:py-16">
      <h2 class="mb-4 text-xl font-bold text-gray-900 dark:text-white">Asignación de Medicamentos</h2>
      <form @submit.prevent="asignarMedicamentos">
        <div class="grid gap-4 sm:grid-cols-2 sm:gap-6">
          <!-- Búsqueda de Paciente -->
          <div class="sm:col-span-2">
            <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Buscar Cliente</label>
            <input v-model="filtroPaciente" @input="buscarPacientes" type="text"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
              placeholder="Ingrese nombre o apellido" />
            <ul v-if="pacientesFiltrados.length"
              class="mt-2 bg-white border border-gray-200 rounded-lg dark:bg-gray-700 dark:border-gray-600">
              <li v-for="paciente in pacientesFiltrados" :key="paciente.id" @click="seleccionarPaciente(paciente)"
                class="px-4 py-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-white">
                {{ paciente.nombre }} {{ paciente.apellido }}
              </li>
            </ul>
          </div>


          <!-- Información del Paciente -->
          <div v-if="pacienteSeleccionado" class="sm:col-span-2 p-4 bg-gray-50 rounded-lg dark:bg-gray-700">
            <p class="text-sm text-gray-900 dark:text-white"><strong>Paciente:</strong>
              {{ pacienteSeleccionado.nombre}} {{pacienteSeleccionado.apellido }}</p>
            <p class="text-sm text-gray-900 dark:text-white"><strong>Dirección:</strong>
              {{ (direccionPaciente || "No disponible") }}</p>
            <p class="text-sm text-gray-900 dark:text-white"><strong>Email:</strong> {{ pacienteSeleccionado.email ||
        "No disponible" }}</p>
            <p v-if="totalPagar > 0" class="text-sm text-gray-900 dark:text-white"><strong>Total a pagar:</strong>$ {{
        totalPagar.toFixed(2) }}</p>
          </div>

          <!-- Selección de Medicamentos -->
          <div class="sm:col-span-2">
            <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Seleccionar Medicamentos</label>
            <div class="space-y-2">
              <div v-for="(med, index) in medicamentos" :key="med.id || index"
                class="flex items-center gap-4 p-3 bg-gray-50 rounded-lg dark:bg-gray-700">
                <div v-if="med.dosisPorFrasco > 0" class="flex-1">
                  <label class="inline-flex items-center">
                    <input type="checkbox" :value="med" v-model="medicamentosSeleccionados" @change="actualizarTotal"
                      class="w-4 h-4 text-blue-600 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600" />
                    <span class="ml-2 text-sm text-gray-900 dark:text-white">
                      {{ med.nombre }} (Disponible: {{ parseFloat(med.dosisPorFrasco) }} dosis) - ${{
        parseFloat(med.precioVentaPorDosis).toFixed(2) }} por dosis
                    </span>
                  </label>
                  <div v-if="medicamentosSeleccionados.includes(med)" class="grid grid-cols-2 gap-2 mt-2">
                    <div>
                      <label class="block mb-1 text-xs font-medium text-gray-700 dark:text-gray-300">Dosis a aplicar:</label>
                      <input v-model.number="dosisSeleccionadas[med.id]"
                        type="number" placeholder="Dosis"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                        min="0" :max="med.dosisPorFrasco" @input="validarDosis(med, dosisSeleccionadas[med.id])" />
                    </div>
                    <div>
                      <label class="block mb-1 text-xs font-medium text-gray-700 dark:text-gray-300">Precio por dosis:</label>
                      <input v-model.number="preciosPersonalizados[med.id]"
                        type="number" placeholder="Precio"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                        min="0" step="0.01" @input="actualizarTotal" />
                    </div>
                  </div>
                </div>
                <span v-else class="text-sm text-red-500 dark:text-red-400">{{ med.nombre }} (No disponible)</span>
              </div>
            </div>
          </div>

          <!-- Selección de Enfermero -->
          <div class="sm:col-span-2">
            <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Seleccionar Enfermero</label>
            <select v-model="enfermeroSeleccionado"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
              required>
              <option value="">Seleccione un enfermero</option>
              <option v-for="enf in enfermeros" :key="enf.id" :value="enf">{{ enf.nombre }}</option>
            </select>
          </div>

          <!-- Fecha y Hora -->
          <div class="w-full">
            <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Fecha de la Cita</label>
            <input v-model="fechaCita" @change="calcularDiaSemana" type="date"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
              required />
          </div>

          <div class="w-full">
            <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Hora de la Cita</label>
            <TimePicker v-model="horaCita" placeholder="Seleccionar hora" />
          </div>

          <div class="w-full">
            <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Día de la Semana</label>
            <input v-model="diaCita" type="text"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
              readonly />
          </div>
        </div>

        <div class="flex justify-center mt-4 sm:mt-6">
          <button type="submit"
            class="inline-flex items-center px-5 py-2.5 text-sm font-medium text-center text-white bg-blue-700 rounded-lg focus:ring-4 focus:ring-blue-200 dark:focus:ring-blue-900 hover:bg-blue-800">
            Asignar Medicamento
          </button>
        </div>
      </form>
    </div>
  </section>
</template>
<script>
import { collection, doc, updateDoc, getDocs, getDoc, addDoc, setDoc } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { db } from '../../firebase';
import TimePicker from '../views/paciente/TimePicker.vue';

export default {
  components: { TimePicker },
  data() {
    return {
      filtroPaciente: "",
      pacientesFiltrados: [],
      pacienteSeleccionado: null,
      direccionPaciente: "",
      totalPagar: 0,
      pacienteEmail: '',
      medicamentosSeleccionados: [],
      dosisSeleccionadas: {},
      preciosPersonalizados: {}, // Nuevo objeto para almacenar precios personalizados
      enfermeroSeleccionado: null,
      fechaCita: "",
      horaCita: "",
      diaCita: "",
      medicamentos: [],
      pacientes: [],
      enfermeros: [],
      codigoEmail: '',
    };
  },
  methods: {
    validarDosis(med, dosis) {
      // Verificamos si la dosis es mayor a la cantidad disponible en el frasco
      if(med.dosisPorFrasco < 10){
        alert('Restockear medicamento, stock inferior a 10')
      }
      if (dosis > med.dosisPorFrasco) {
        alert(`La dosis máxima permitida para ${med.nombre} es ${med.dosisPorFrasco} dosis.`);
        this.dosisSeleccionadas[med.id] = med.dosisPorFrasco; // Ajustamos la dosis al stock disponible
      } else if (dosis <= 0) {
        alert(`La dosis seleccionada debe ser mayor a 0.`);
        this.dosisSeleccionadas[med.id] = 1; // Establecemos una dosis mínima válida
      }

      // Actualizamos el total después de validar la dosis
      this.actualizarTotal();
    },
    generarCodigoAleatorio() {
      const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*';
      let codigoEmail = '';
      for (let i = 0; i < 8; i++) {
        const indiceAleatorio = Math.floor(Math.random() * caracteres.length);
        codigoEmail += caracteres[indiceAleatorio];
      }
      return codigoEmail;
    },

    async cargarDatos() {
      this.enfermeros = await this.cargarEnfermeros();
      this.pacientes = await this.cargarPacientes();
      this.medicamentos = await this.cargarMedicamentos();
    },
    async cargarEnfermeros() {
      const querySnapshot = await getDocs(collection(db, "enfermeros"));
      const enfermeros = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      return enfermeros
    },
    async cargarPacientes() {
      const querySnapshot = await getDocs(collection(db, "pacientes"));
      return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    },
    async cargarMedicamentos() {
      const querySnapshot = await getDocs(collection(db, "medicamentos"));
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        nombre: doc.data().nombre,
        dosisPorFrasco: doc.data().dosisPorFrasco || 0,
        precioVentaPorDosis: doc.data().precioVentaPorDosis || 0,   
        img : doc.data().img
      }));
    },
    buscarPacientes() {
      const filtro = this.filtroPaciente.toLowerCase();
      if(filtro ===""){
        this.pacientesFiltrados = []
        return
      }
      this.pacientesFiltrados = this.pacientes.filter(paciente =>
        (paciente.nombre ).toLowerCase().includes(filtro) ||
        (paciente.apellido).toLowerCase().includes(filtro)
      );
    },
    async seleccionarPaciente(paciente) {
  this.filtroPaciente = "";
  this.pacientesFiltrados = [];
  this.pacienteSeleccionado = paciente;
  
  // This is the line causing the error - incorrect use of getDoc
  // const pacienteDoc = await getDoc(db, "pacientes", paciente.id);
  
  // Correct way to get a document reference and then fetch it
  const pacienteRef = doc(db, "pacientes", paciente.id);
  const pacienteDoc = await getDoc(pacienteRef);
  
  if (pacienteDoc.exists()) {
    const pacienteData = pacienteDoc.data();
    this.pacienteSeleccionado.apellido = pacienteData.apellido;
    this.pacienteSeleccionado.telefono = pacienteData.telefono || 'No disponible';
    this.direccionPaciente = pacienteData.direccion || 'No disponible';
    this.pacienteEmail = pacienteData.email || 'No tiene email';
    this.pacienteSeleccionado.direccion = pacienteData.direccion || "No tiene direccion";
  }
},
    actualizarTotal() {
      this.totalPagar = this.medicamentosSeleccionados.reduce((total, med) => {
        const dosis = this.dosisSeleccionadas[med.id] || 0;
        // Usar el precio personalizado si existe, de lo contrario usar el precio predeterminado
        const precio = this.preciosPersonalizados[med.id] !== undefined ? 
                      this.preciosPersonalizados[med.id] : 
                      Number.parseFloat(med.precioVentaPorDosis) || 0;

        if (dosis > 0 && precio > 0) {
          return total + (precio * dosis);
        }
        return total;
      }, 0);

      if (isNaN(this.totalPagar) || !isFinite(this.totalPagar)) {
        this.totalPagar = 0;
      }
    },
    calcularDiaSemana() {
      if (!this.fechaCita) return;

      // Dividimos la fecha en año, mes y día
      const [year, month, day] = this.fechaCita.split('-');

      // Creamos un objeto Date con estos valores, teniendo en cuenta que el mes se cuenta desde 0
      const fecha = new Date(year, month - 1, day);

      // Configuración de opciones de formato en español
      const opciones = { weekday: 'long' };

      // Convertimos la fecha a día de la semana
      this.diaCita = fecha.toLocaleDateString('es-ES', opciones);
    },
    async asignarMedicamentos() {
      if (!this.pacienteSeleccionado || !this.enfermeroSeleccionado || this.medicamentosSeleccionados.length === 0) {
        alert('Debe seleccionar un paciente, un enfermero y al menos un medicamento.');
        return;
      }

      const horaCitaFormateada = this.horaCita.split(':').slice(0, 2).join(':');


      // Verificación de que la dirección no sea undefined
      const direccionPaciente = this.pacienteSeleccionado.direccion || 'No disponible';
      if (direccionPaciente === undefined) {
        console.error("La dirección del paciente es undefined.");
        return;
      }

      // Solo continúa si la dirección es válida
      const fechaHoy = new Date().toISOString().split('T')[0];
      const finanzasDocRef = doc(db, "finanzas", fechaHoy);
      await setDoc(finanzasDocRef, { fecha: fechaHoy }, { merge: true });

      for (const med of this.medicamentosSeleccionados) {
        if (med.dosisPorFrasco <= 0) {
          console.warn(`El medicamento ${med.nombre} no tiene stock suficiente.`);
          continue; // Salta a la siguiente iteración si no hay stock
        }
        const dosis = this.dosisSeleccionadas[med.id] || 1;
        if (dosis <= 0) {
          console.error(`La dosis del medicamento ${med.nombre} es inválida.`);
          continue; // Salta si la dosis es menor o igual a 0
        }

        const medicamentoRef = doc(db, "medicamentos", med.id);
        const nuevaCantidad = med.dosisPorFrasco - dosis;
        await updateDoc(medicamentoRef, { dosisPorFrasco: nuevaCantidad > 0 ? nuevaCantidad : 0 });

        // Usar el precio personalizado si existe, de lo contrario usar el precio predeterminado
        // const precioUsado = this.preciosPersonalizados[med.id] !== undefined ? 
        //                   this.preciosPersonalizados[med.id] : 
        //                   parseFloat(med.precioVentaPorDosis);
        
        const gasto = (dosis * parseFloat(med.precioVentaPorDosis));
        await addDoc(collection(finanzasDocRef, "gastos"), {
          medicamento: med.nombre,
          dosis: dosis,
          costo: gasto,
          tipo: "despacho"
        });
      }
      
      const cita = {
        fecha: this.fechaCita,
        hora: horaCitaFormateada,
        dia: this.diaCita,
        paciente: this.pacienteSeleccionado.nombre,
        apellido: this.pacienteSeleccionado.apellido,
        telefono: this.pacienteSeleccionado.telefono,
        email: this.pacienteSeleccionado.email,
        pacienteId: this.pacienteSeleccionado.id,
        direccion: this.pacienteSeleccionado.direccion,
        medicamentos: this.medicamentosSeleccionados.map(med => ({
          nombre: med.nombre,
          dosis: this.dosisSeleccionadas[med.id] || 1,
          precioPersonalizado: this.preciosPersonalizados[med.id],
          img: med.img != null ? med.img : ""
        })),
        costoTotal: isNaN(this.totalPagar) || !isFinite(this.totalPagar) ? 0 : this.totalPagar
      };

      const functions = getFunctions();
      this.codigoEmail = this.generarCodigoAleatorio();
      const enviarCorreo = httpsCallable(functions, 'enviarCodigoConfirmacion');

      await enviarCorreo({
        email: this.pacienteSeleccionado.email,
        nombre: this.pacienteSeleccionado.nombre,
        apellido: this.pacienteSeleccionado.apellido,
        telefono: this.pacienteSeleccionado.telefono,
        codigoConfirmacion: this.codigoEmail,
        medicamentos: this.medicamentosSeleccionados,
      });
      const sendSms = httpsCallable(functions, 'sendSms');

      if (!this.pacienteSeleccionado.telefono.toString().startsWith('+1')) {
        this.pacienteSeleccionado.telefono = '+1' + this.pacienteSeleccionado.telefono.toString();
        } 
// Primero eliminamos al usuario de Firebase Auth
await sendSms({message:` Saludos y Espectacular día para ti!

Se ha programado una cita para el día ${this.fechaCita} a las ${horaCitaFormateada}

Vitaliza
Vitaminas Intravenosas y Control de Peso`,to:this.pacienteSeleccionado.telefono});
      if (!this.enfermeroSeleccionado.citas) {
        this.enfermeroSeleccionado.citas = [];
      }

      const enfermeroRef = doc(db, "enfermeros", this.enfermeroSeleccionado.id);
      await updateDoc(enfermeroRef, { citas: [...(this.enfermeroSeleccionado.citas || []), cita] });
      await addDoc(collection(db, "citasGlobales"), {
        ...cita,
        enfermero: this.enfermeroSeleccionado.id,
        codigoEmail: this.codigoEmail,
        paciente: {
          nombre: this.pacienteSeleccionado.nombre || "Sin nombre",
          apellido: this.pacienteSeleccionado.apellido || "Sin apellido",
          telefono: this.pacienteSeleccionado.telefono || "Sin teléfono",
          email: this.pacienteSeleccionado.email || "Sin email",
          direccion: this.pacienteSeleccionado.direccion || "Sin direccion",
        },
        estado: "pendiente", // Estado inicial
        prioridad: "normal", // Nivel de prioridad
        fechaCreacion: this.fechaCita,
      });


      await addDoc(collection(finanzasDocRef, "ingresos"), {
        enfermeroId: this.enfermeroSeleccionado.id,
        citaId: cita.paciente,
        pacienteId: this.pacienteSeleccionado.id,
        costoTotal: cita.costoTotal,
        tipoPago: "Pendiente",
        medicamentos: this.medicamentosSeleccionados.map(med => ({
          nombre: med.nombre,
          dosis: this.dosisSeleccionadas[med.id] || 1,
          precioVenta: this.preciosPersonalizados[med.id] !== undefined ? 
                      this.preciosPersonalizados[med.id] : 
                      parseFloat(med.precioVentaPorDosis),
          precioOriginal: parseFloat(med.precioVentaPorDosis)
        }))
      });

      alert("Medicamentos asignados, cita creada, y registro en finanzas actualizado con éxito.");
      this.limpiarFormulario();
      this.cargarDatos();
    },
    limpiarFormulario() {
      this.filtroPaciente = '';
      this.pacienteSeleccionado = null;
      this.direccionPaciente = '';
      this.pacienteEmail = '';
      this.totalPagar = 0;
      this.medicamentosSeleccionados = [];
      this.dosisSeleccionadas = {};
      this.preciosPersonalizados = {}; // Limpiar precios personalizados
      this.enfermeroSeleccionado = null;
      this.fechaCita = '';
      this.horaCita = '';
      this.diaCita = '';
    }
  },
  mounted() {
    this.cargarDatos();
  },
  watch: {
    // Inicializar precios personalizados cuando se selecciona un medicamento
    medicamentosSeleccionados: {
      handler(newVal) {
        newVal.forEach(med => {
          // Si no hay un precio personalizado establecido, inicializarlo con el precio predeterminado
          if (this.preciosPersonalizados[med.id] === undefined) {
            this.preciosPersonalizados[med.id] = Number.parseFloat(med.precioVentaPorDosis);
          }
        });
      },
      deep: true
    }
  }
};
</script>

<style scoped>
/* No se necesitan estilos adicionales ya que usamos Tailwind */
</style>
